import { ModulesMap, ModulesConfigMap } from "../data/modulesMaps"

export default {
	[ModulesConfigMap[ModulesMap.COMPANY_FUEL_SETTINGS].GET_COMPANY_FUEL_SETTINGS]: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.COMPANY_FUEL_SETTINGS].GET_COMPANY_FUEL_SETTINGS,
	},
	[ModulesConfigMap[ModulesMap.COMPANY_FUEL_SETTINGS].PATCH_COMPANY_FUEL_SETTINGS]: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.COMPANY_FUEL_SETTINGS].PATCH_COMPANY_FUEL_SETTINGS,
	},
}
